import { render, staticRenderFns } from "./orderTabSix.vue?vue&type=template&id=95798ef8&scoped=true"
import script from "./orderTabSix.vue?vue&type=script&lang=js"
export * from "./orderTabSix.vue?vue&type=script&lang=js"
import style1 from "./orderTabSix.vue?vue&type=style&index=1&id=95798ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95798ef8",
  null
  
)

export default component.exports